<template>
  <BaseView>
    <div class="cms-layout">
      <!-- Barra lateral de progreso -->
      <LeftSideBar />

      <!-- Área principal donde se muestra ProjectConfig o NotionComponent -->
      <div class="main-view">
        <ProjectConfig v-if="cmsView === 1" />
        <ToolsComponent v-if="cmsView === 2" />
        <NotionComponent
          v-if="cmsView === 3"
          :page="$store.state.index_page_selected"
          :key="$store.state.index_page_selected"
          :editing="editing"
        />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from "./BaseView.vue";
import LeftSideBar from "@/components/cms/LeftSideBar.vue";
import ProjectConfig from "@/components/cms/ProjectConfig.vue";
import NotionComponent from "@/components/cms/NotionComponent.vue";
import ToolsComponent from "@/components/cms/ToolsComponent.vue";

export default {
  name: "CmsView",
  components: {
    BaseView,
    LeftSideBar,
    ProjectConfig,
    NotionComponent,
    ToolsComponent,
  },
  computed: {
    cmsView() {
      return this.$store.state.cms_view;
    },
  },
  watch: {},
  data() {
    return {
      editing: false,
    };
  },
  created() {
    if(this.$route.params.projectId){
      console.log('Utilizando el modo edición');
      this.editing = true;
      this.$store.commit('updateNewProject', {...JSON.parse(sessionStorage.getItem('project_edit'))});
    }else{
      console.log('Utilizando el modo creación');
    }
  },
};
</script>

<style scoped>
.cms-layout {
  display: flex;
  height: 100vh;
  overflow-y: auto;
}

.main-view {
  flex: 1;
  background-color: transparent;
}
</style>
